import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { Step, StepsResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class StepsDataService {

  private uri: string = `${environment.apiUrl}list-step`;
  private cacheKey: string = 'steps.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getStep(id: number): Observable<Step|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getSteps(parameters: {[param: string]: string | string[]}): Observable<StepsResult|any> {
    return this.http.get(this.uri + `/all`, {params: parameters});
  }

  addStep(data: Step): Observable<Step|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri + `/add`, cleanData);
  }

  addSteps(data: Step[]): Observable<Step[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateStep(data: Step): Observable<Step|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateSteps(data: Step[]): Observable<Step[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchStep(data: Step): Observable<Step|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchSteps(data: Step[]): Observable<Step[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteStep(data: Step): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteSteps(data: Step[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((step) => {
      ids.push(step.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
